<template>
    <div>
        <section class="hero hero-slider-wrapper hero-style-1">
            <div class="hero-slider slick-initialized slick-slider">
                <div aria-live="polite" class="slick-list draggable">
                    <div class="slick-track" role="listbox" style="opacity: 1; ">
                        <div class="slide slick-slide slick-current slick-active w-100" data-slick-index="0"
                             aria-hidden="false" tabindex="-1" role="option" aria-describedby="slick-slide00"
                             style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1; background-image: url('/assets/images/spaceneedle-1.jpg'); background-size: cover; background-position: center center;">
                            <div class="rect"></div>
                            <img src="/assets/images/spaceneedle-1.jpg" alt="" class="slider-bg">
                            <div class="container">
                                <div class="row">
                                    <div class="col col-lg-6 col-sm-10 slide-caption">
                                        <div class="slide-subtitle"><h5>Welcome to Streamline</h5></div>
                                        <div class="slide-title"><h2>AV Design and Installation</h2></div>
                                        <div class="btns"><a href="#more" class="theme-btn" tabindex="0">Explore More</a>
                                        <router-link :to="{name: 'contact-us'}" class="theme-btn-s2" tabindex="0">Get in touch</router-link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- end of hero slider -->
    </div>
</template>
<script>

    export default {

    }
</script>
